( function () {
	'use strict';

	function createSchedule ( moment, Session, apiService, editschedservice ) {
		var credentials = Session.getCredentials();

		function disableYears ( date ) {
			return moment( new Date() ).format( 'YYYY' ) > moment( date ).format( 'YYYY' );
		}

		function disableMonths ( date ) {
			return moment( new Date() ).format( 'YYYYMM' ) > moment( date ).format( 'YYYYMM' );
		}

		function disableDays ( date ) {
			return moment( new Date() ).format( 'YYYYMMDD' ) > moment( date ).format( 'YYYYMMDD' );
		}

		var modes = {
			'year'  : disableYears,
			'month' : disableMonths,
			'day'   : disableDays
		};

		function disableDates ( date, mode ) {
			return modes[ mode ]( date );
		}

		function invalidDate ( date ) {
			return !moment( date, 'MM/DD/YY' ).isValid();
		}

		function incorrectTime ( eventDate, startTime, endTime, dateToday ) {
			var mmntEventDate = moment( eventDate );
			var mmntStartTime = moment( startTime );
			var mmntDateToday = moment( dateToday || new Date() );

			return mmntEventDate.format( 'YYYYMMDD' ) === mmntDateToday.format( 'YYYYMMDD' ) && mmntDateToday.format( 'HHmm' ) > mmntStartTime.format( 'HHmm' );
		}

		function formatDefaultDate ( date ) {
			return moment( date ).format();
		}

		function getCurrentDate ( addTime ) {
			var offset       = 30 * 60 * 1000;
			var startTime    = new Date();
			var newStartTime = new Date( Math.ceil( startTime.getTime() / offset ) * offset );

			if ( addTime ) {
				return moment( newStartTime ).add( addTime, 'h' ).format();
			}

			return moment( newStartTime ).format();
		}

		function getEndTime () {
			return moment( new Date() ).add( 1, 'h' );
		}

		function getClientId () {
			return credentials.ClientId;
		}

		function getUserId () {
			return credentials.userId;
		}

		function getSchools () {
			return apiService.users
				.query( {
					'userId' : getUserId(),
					'rights' : 'create'
				} )
				.$promise;
		}

		function getTemplate ( templateId ) {
			return apiService.template
				.get( {
					'userId'     : getUserId(),
					'templateId' : templateId
				} )
				.$promise.then( function ( res ) {
					return res;
				} );
		}

		function getTemplates () {
			return apiService.templates
				.query( {
					'userId' : getUserId()
				} )
				.$promise.then( function ( res ) {
					return res;
				} );
		}

		function getUsers ( userId ) {
			return apiService.observation
				.get( {
					'userId' : userId
				} )
				.$promise.then( function ( res ) {
					return res;
				} );
		}

		return {
			'disableDates'      : disableDates,
			'invalidDate'       : invalidDate,
			'incorrectTime'     : incorrectTime,
			'incorrectEndTime'  : editschedservice.incorrectEndTime,
			'formatDefaultDate' : formatDefaultDate,
			'getCurrentDate'    : getCurrentDate,
			'getEndTime'        : getEndTime,
			'getClientId'       : getClientId,
			'getUserId'         : getUserId,
			'getSchools'        : getSchools,
			'getTemplate'       : getTemplate,
			'getTemplates'      : getTemplates,
			'getUsers'          : getUsers
		};
	}

	angular
		.module( 'app.schedules' )
		.factory( 'createschedservice', createSchedule );

	createSchedule.$inject = [ 'moment', 'Session', 'apiService', 'editschedservice' ];
} )( );
